import axios from 'axios';

import { API_URL } from '../config';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Authorization': `Bearer ${localStorage.getItem('token')}`,
    'Content-Type': 'application/json',
  }
});

export interface User {
  id: number;
  name: string;
  email: string;
  /** organizer / invitee, and when an invitee first opened the event (both from the pivot table) */
  pivot?: {
    type?: string;
    read_at?: string | null;
  };
}

export interface CalendarEvent {
  id: number;
  name: string;
  description: string | null;
  date: string;
  time: string;
  users: User[];
  created_at: string;
  updated_at: string;
}

export interface CreateEventRequest {
  name: string;
  description?: string;
  date: string;
  time: string;
  user_ids?: number[];
}

export const calendarService = {
  getEvents: async (month: number, year: number): Promise<CalendarEvent[]> => {
    const response = await api.get('/calendar-events', {
      params: { month, year }
    });
    return response.data.data;
  },

  createEvent: async (data: CreateEventRequest): Promise<CalendarEvent> => {
    const response = await api.post('/calendar-events', data);
    return response.data.data;
  },

  deleteEvent: async (id: number): Promise<void> => {
    await api.delete(`/calendar-events/${id}`);
  }
};
